module.exports = prestashop;


//////////////////
// WEBPACK FOOTER
// external "prestashop"
// module id = 61
// module chunks = 0